import React from "react";
import styled from "styled-components";
import moment from "moment";
import { useTranslate } from '@tolgee/react';
import { Repeat } from "lucide-react";
import { useMeetingJoinGrace } from "../../hooks/useMeetingJoinGrace";

const PastMeetingListElement = ({
  data,
  selected,
  handleJoinMeeting,
  handleSelectMeeting,
}) => {
  const { t } = useTranslate();
  const { inGracePeriod, endedLabel, expiresLabel } = useMeetingJoinGrace(data);

  const handleJoinMeetingNoPropagation = (e) => {
    e.stopPropagation();
    handleJoinMeeting(data);
  };

  return (
    <MeetingELementContainer
      selected={selected}
      onClick={() => handleSelectMeeting(data)}
    >
      <MeetingDetails>
        <Line>
          {data.recurring_meeting_series_id && <RecurringIcon size={13} />}
          <MeetingTitle>{data.title}</MeetingTitle>
          {inGracePeriod ? (
            <RejoinCell onClick={handleJoinMeetingNoPropagation}>
              {t('meetings.rejoin')}
            </RejoinCell>
          ) : (
            <TimeCell>
              {moment(data.start_at).format("HH:mm")} – {moment(data.end_at).format("HH:mm")}
            </TimeCell>
          )}
        </Line>
        <Line>
          {inGracePeriod ? (
            <>
              <MeetingDescription>
                {t('meetings.ended_ago', { time: endedLabel })}
              </MeetingDescription>
              <DateCell>{t('meetings.expires', { time: expiresLabel })}</DateCell>
            </>
          ) : (
            <>
              <MeetingDescription>{data.description}</MeetingDescription>
              <DateCell>{moment(data.start_at).format("DD.MM.YYYY")}</DateCell>
            </>
          )}
        </Line>
      </MeetingDetails>
    </MeetingELementContainer>
  );
};

export default PastMeetingListElement;

const MeetingELementContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
  align-items: center;
  padding: 13px 16px;
  background: ${({ selected, theme }) =>
    selected ? theme.chat.selectedBackground : theme.menu.background};
  &:hover {
    background: ${({ theme }) => theme.chat.selectedBackground};
  }
`;

const MeetingDetails = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 5px;
`;
const MeetingTitle = styled.h3`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: ${({ theme }) => theme.menu.primaryTextColor};
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const RecurringIcon = styled(Repeat)`
  flex-shrink: 0;
  color: ${({ theme }) => theme.menu.selectedTextColor};
`;
const MeetingDescription = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Line = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
const TimeCell = styled.p`
  margin-left: auto;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  text-align: left;
  white-space: nowrap;
`;

const DateCell = styled.p`
  margin-left: auto;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  text-align: left;
  white-space: nowrap;
`;

const RejoinCell = styled.p`
  margin-left: auto;
  color: ${({ theme }) => theme.menu.selectedTextColor};
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  text-align: left;
  background: transparent;
  border: 1px solid ${({ theme }) => theme.menu.selectedTextColor};
  padding: 2px 10px;
  border-radius: 8px;
  white-space: nowrap;
  flex-shrink: 0;
`;
